import { db } from '../firebase';
import { doc, runTransaction } from 'firebase/firestore';

const withoutUndefinedFields = (data) =>
    Object.fromEntries(Object.entries(data).filter(([, value]) => value !== undefined));

async function saveOrgAndUserDataTransaction(orgId, userId, orgData, userData) {
    try {
        await runTransaction(db, async (transaction) => {
            const orgRef = doc(db, 'Organizations', orgId);
            const userRef = doc(db, 'Store', userId);

            transaction.set(orgRef, withoutUndefinedFields(orgData), { merge: true });
            transaction.set(userRef, withoutUndefinedFields(userData), { merge: true });
        });
    } 
    catch (error) {
        console.error("Transaction Firestore échouée :", error);
        throw error;
    }
}

export default saveOrgAndUserDataTransaction;
